/**
 * Returns the preferred external identifier for URL paths.
 *
 * Priority: short_code (7-digit, cleanest URL) → uuid → integer id
 *
 * Usage:
 *   navigate(`/matches/${eid(match)}/live`)   // → /matches/2847362/live
 *   navigate(`/teams/${eid(team)}`)
 *
 * The backend resolveId middleware accepts all three formats,
 * so any identifier works — short_code is preferred for brevity.
 */
export const eid = (entity) =>
  entity?.shortCode || entity?.short_code || entity?.uuid || entity?.id;

/**
 * Get a team identifier from a raw team_id (integer) and an optional
 * teams array that has uuid/shortCode info.  Falls back to the numeric id.
 */
export const eidFromId = (id, entitiesArray = []) => {
  if (!id) return id;
  const found = entitiesArray.find((e) => e.id === id || e.id === Number(id));
  return found?.shortCode || found?.short_code || found?.uuid || id;
};
